import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appPhoneNumber]',
})
export class PhoneNumberDirective {
  private regex: RegExp = new RegExp(/^[0-9]*$/); // Only allow numbers
  private specialKeys: Array<string> = [
    'Backspace',
    'Tab',
    'End',
    'Home',
    'ArrowLeft',
    'ArrowRight',
    'Delete',
  ];

  constructor(private el: ElementRef) {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }

    let current: string = this.el.nativeElement.value.replace(/\D/g, '');
    if (!this.regex.test(event.key) || current.length >= 11) {
      event.preventDefault();
    }
  }

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    let inputElement = event.target as HTMLInputElement;
    let value = inputElement.value.replace(/\D/g, ''); // Remove all non-digit characters

    if (value.length > 11) {
      value = value.substring(0, 11); // Trim to 11 characters
    }

    inputElement.value = this.formatPhoneNumber(value);
  }

  private formatPhoneNumber(value: string): string {
    let formatted = value;

    if (value.length > 4) {
      formatted = `(${value.substring(0, 4)}) ${value.substring(4)}`;
    } else if (value.length > 0) {
      formatted = `(${value}`;
    }

    return formatted;
  }
}
